import { combineReducers } from 'redux';
import report from './report.reducers';
import alert from './alert.reducers';
import signIn from './signIn.reducers';


export const appReducer = combineReducers({
  report,
  alert,
  signIn
 });

export const rootReducer = (state, action) => {
  if (action.type === 'LOGOUT_USER'){
    localStorage.clear();
    state = undefined;
  }
  return appReducer(state, action)
};